import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	heartbeatLimitBanner: {
		id: 'eoc.heartbeats.banner.no-translate',
		defaultMessage: `You've reached limit of {limit} heartbeats. Please remove some heartbeats or contact your admin for assistance. `,
		description: 'Description of the heartbeat banner',
	},
	viewInOgText: {
		id: 'eoc.heartbeats.banner.view-in-og.no-translate',
		defaultMessage: 'View heartbeats in Opsgenie',
		description: 'View in Opsgenie text',
	},
});

export default messages;
